import { render, staticRenderFns } from "./view.html?vue&type=template&id=d7dd434e&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=d7dd434e&lang=less&scoped=true&"
import style1 from "./style_notebook.less?vue&type=style&index=1&id=d7dd434e&lang=less&scoped=true&"
import style2 from "./style_mobile.less?vue&type=style&index=2&id=d7dd434e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dd434e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7dd434e')) {
      api.createRecord('d7dd434e', component.options)
    } else {
      api.reload('d7dd434e', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=d7dd434e&scoped=true&", function () {
      api.rerender('d7dd434e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/poggi/index.vue"
export default component.exports